"use client";

import type { FC } from "react";
import { useState } from "react";
import { cn } from "@/lib/cn";

type PractitionerAvatarProps = {
  name?: string;
  photoUrl?: string;
  className?: string;
};

const getInitials = (name?: string) => {
  const initials = (name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("");
  return initials || "?";
};

export const PractitionerAvatar: FC<PractitionerAvatarProps> = ({ name, photoUrl, className }) => {
  const [errored, setErrored] = useState(false);
  const showImage = Boolean(photoUrl) && !errored;

  return (
    <div className={cn("relative overflow-hidden rounded-medium bg-tone-ice", className)}>
      {showImage ? (
        <img
          src={photoUrl}
          alt={name ?? ""}
          onError={() => setErrored(true)}
          className="absolute inset-0 size-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex size-full items-center justify-center text-brand-dark-blue text-24 font-semibold">
          {getInitials(name)}
        </div>
      )}
    </div>
  );
};
